var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rock-table-button"},[(_vm.isMobile)?_c('vxe-button',{attrs:{"status":_vm.type,"icon":_vm.icon,"size":_vm.vxeSize,"circle":""},on:{"click":_vm.handleClick}}):_c('vxe-button',{attrs:{"status":_vm.type,"icon":_vm.icon,"size":_vm.vxeSize,"content":_vm.title},on:{"click":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }